import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateDeliveryDiscountEntity } from '../../domain/entities/CreateUpdateDeliveryDiscountEntity'
import type { DeliveryDiscountPeriodEntity } from '../../domain/entities/DeliveryDiscountEntity'

export class CreateUpdateDeliveryDiscountModel extends CreateUpdateDeliveryDiscountEntity {
  branchIds?: Array<number> | null
  declare startDate: string
  declare endDate: string
  constructor(dataDto: CreateUpdateDeliveryDiscountEntity) {
    super()
    const days = dataDto.days?.filter((shift) => shift.periods && shift.periods?.length > 0)
    mapEntityProperties<CreateUpdateDeliveryDiscountModel>(this, dataDto, {
      exclude: ['branches'],
      map: {
        branchIds: dataDto.branches?.map((branch) => branch.id),
        days: days?.map((shift) => ({
          dayOfWeek: shift.dayOfWeek,
          periods: shift.periods?.map((period: DeliveryDiscountPeriodEntity) => {
            if (!period.startTimeDayOfWeek) {
              period.startTimeDayOfWeek = shift.dayOfWeek
            }
            if (!period.endTimeDayOfWeek) {
              period.endTimeDayOfWeek = shift.dayOfWeek
            }
            return {
              startTime: period.startTime,
              endTime: period.endTime,
              startTimeDayOfWeek: period.startTimeDayOfWeek,
              endTimeDayOfWeek: period.endTimeDayOfWeek
            }
          })
        })),
        segments: dataDto.segments?.map((segment) => ({
          ...segment,
          branchRatio: segment.shareType === 'Amount' ? null : segment.branchRatio,
          serviceRatio: segment.shareType === 'Amount' ? null : segment.serviceRatio,
          limitedBranchShareAmount:
            segment.shareType === 'Amount' ? segment.limitedBranchShareAmount : null
        }))
      }
    })
  }
}
